import { FC } from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

import useDesignConstants from '../../hooks'

import './styles.scss'

const ThemeMenu: FC = () => {
  const { menuItems } = useDesignConstants()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleNavigation = (navigateTo: string) => navigate(navigateTo)

  return (
    <div className="theme-design-menu">
      <div className="theme-design-menu__title">
        {t('tenantDesign.menu.title')}
      </div>
      <hr className="theme-design-menu__separator" />
      <div className="theme-design-menu__menu-options">
        {menuItems &&
          menuItems.map((menuItem) => (
            <div
              key={menuItem.index}
              className={classNames(
                'theme-design-menu__menu-options__option',
                menuItem.value === 'theme' &&
                  'theme-design-menu__menu-options__option active'
              )}
              onClick={() => handleNavigation(`../${menuItem.value}`)}
            >
              {menuItem.name}
            </div>
          ))}
      </div>
    </div>
  )
}

export default ThemeMenu
